import * as types from './types';

function setStationDetails(stationId, data) {
    return {
        meta: stationId,
        payload: data,
        type: types.SET_STATION_DETAILS,
    };
}

export {
    setStationDetails,
};
